// extracted by mini-css-extract-plugin
export var backdropBlur = "_mt-0";
export var contentCard = "_mt-5";
export var frame = "_mt-2";
export var image = "_mt-4";
export var imagePane = "_mt-3";
export var modal = "_mt-1";